import { type FC } from 'react';

import classnames from 'classnames';
import dibsCss from 'dibs-css';
import styles from '../styles/styles.scss';

type Props = {
    urgencySignal?: string | null;
};

export const ProductUrgencySignal: FC<Props> = ({ urgencySignal }) => {
    if (!urgencySignal) {
        return null;
    }

    return (
        <span
            className={classnames(
                styles.urgencySignalPill,
                dibsCss.textBodyXSmallHeavy,
                dibsCss.textAlertsecondary,
                dibsCss.absolute,
                dibsCss.leftXxsmall,
                dibsCss.pxXsmall,
                dibsCss.py3px,
                dibsCss.roundedFull
            )}
        >
            {urgencySignal}
        </span>
    );
};
